import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";
import { TimeFragmentSerializer } from "./TimeFragmentSerializer";

export class PeriodFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.StartPeriod;
    }

    getRawFragment(play, serializationContext, fragment) {
        const { gameContext } = serializationContext;
        const {
            currentPeriod,
            homeTeamHasPossession,
            driveContext,
            fieldPosition
        } = gameContext;
        let rawPlay = "";
        const rawTimeFragment = new TimeFragmentSerializer().getRawFragment(
            null,
            serializationContext,
            null
        );

        const spotValues = [
            homeTeamHasPossession ? "H" : "V",
            this.resolveFormattedFieldPosition({ gameContext }, fieldPosition),
            driveContext?.triggerDrive ? "Y" : "N"
        ];
        const periodSpot = `SPOT:${spotValues.join()}`;

        rawPlay = `Q:${currentPeriod} ${rawTimeFragment} ${periodSpot}`;

        return rawPlay;
    }
}
